<template>
  <div class="index">
    <div class="header" :class="isQiankunEnv ? 'qiankunheader' : ''" >
      <img src="https://ccrc-biz-public.oss-cn-hangzhou.aliyuncs.com/web/datva/nav-img.png"
           alt=""
           width="100%"
           height="220px">
      <div class="btn" >
        <div class="back-btn" >
          <el-button
            v-if="isQiankunEnv"
            class="logout"
            size="mini"
            @click="backHome"
            type="danger"
            >返回</el-button>
        </div>
      </div>     
      <div class="logo">
        <span>{{$website.name}}</span>
        <small>{{$website.subName}}</small>
      </div>
      <navs @change="handleChange"></navs>
    </div>
    <div class="main">
      <router-view />
    </div>
  </div>
</template>
<script>
import { getList } from '@/api/glob'
import navs from './nav/index'
export default {
  name: "index",
  components: {
    navs,
  },
  data () {
    return {
    }
  },
  computed: {
    isQiankunEnv() {
      return window.__POWERED_BY_QIANKUN__;
    }
  },
  created () {
    this.initGlob();
  },
  mounted () {
    if (this.$website.isDemo) {
      // this.$notify({
      //   dangerouslyUseHTMLString: true,
      //   title: 'Avue-Data大屏-完整源码版',
      //   message: `点击购买`,
      //   duration: 0,
      //   onClick: () => {
      //     window.open('https://avuejs.com/views/pay/')
      //   }
      // });
    }
  },
  methods: {
    backHome(){
      if(process.env.NODE_ENV === "development"){
        window.location.assign("http://localhost:5000/systemview");
      }else{
        window.location.assign("https://test.lcchunyi.com/systemview");
      }
    },
    initGlob () {
      getList({
        current: 1,
        size: 100,
      }).then(res => {
        let list = res.data.data.records
        list.forEach(ele => {
          window.$glob[ele.globalKey] = ele.globalValue
        })
      })
    },
    handleChange (item, index) {
      this.$router.push({ path: item.path })
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/list.scss";
.index {
  height: 100%;
  display: flex;
  flex-direction: column;

  .header {
    flex-shrink: 0;
    position: relative;
    .nav {
      margin: 0 20px;
      width: 100%;
      position: absolute;
      bottom: 10px;
      border: none;
      .el-menu-item {
        background-color: rgba(0, 0, 0, 0) !important;
      }
    }
  }
  .qiankunheader{
    .logo {
      position: absolute;
      top: 30px;
      left: 90px;
    }
    .btn{
      position: absolute;
      top: 50px;
      left: 20px;
    }
  }
  .main {
    width: 100%;
    flex: 1;
    height: 0;
  }
  .content {
    overflow-x: hidden;
  }
  .logo {
    position: absolute;
    top: 30px;
    left: 20px;
  }
}
</style>
